import React from 'react';

import NodeGraph from './NodeGraph';

function PurePrimeClockGraph() {
  // To avoid a rehydration error, where the time on the server
  // is different from the time on the client, we'll make this
  // component client-side-only
  const [hasMounted, setHasMounted] = React.useState(false);

  // Rules of Hooks is upset because of the unconditional state change, but I know it's fine.
  // eslint-disable-next-line
  React.useEffect(() => {
    setHasMounted(true);
  });

  if (!hasMounted) {
    return null;
  }

  return (
    <NodeGraph
      initialState={{
        time: new Date(),
        selectedNum: 10,
      }}
      rows={[
        [
          {
            label: 'App',
            ownsState: 'time',
            dependsOnState: 'time',
          },
        ],
        [
          {
            label: 'Clock',
            parentId: 'app',
            isPureSecretly: true,
            dependsOnState: 'time',
          },
          {
            label: 'PurePrimeCalculator',
            parentId: 'app',
            ownsState: 'selectedNum',
            dependsOnState: 'selectedNum',
            isPure: true,
          },
        ],
      ]}
    />
  );
}

export default PurePrimeClockGraph;
